import { render, staticRenderFns } from "./PGrid.vue?vue&type=template&id=ea1cfe48&scoped=true&"
import script from "./PGrid.vue?vue&type=script&lang=js&"
export * from "./PGrid.vue?vue&type=script&lang=js&"
import style0 from "./PGrid.vue?vue&type=style&index=0&id=ea1cfe48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1cfe48",
  null
  
)

export default component.exports